import React, { useState, useEffect } from 'react'

const CBRadio = props => {
  const [poweredOn, setPoweredOn] = useState(false);
  const cbRadioAudio = 'CBRadio';

  useEffect(() => {
    return () => {
      props.audioController.removeAudio(cbRadioAudio);
    }
  }, [])
  useEffect(() => { // showing fail-screen does not unmount this component so let's manually remove audio
    props.audioController.removeAudio(cbRadioAudio);
  }, [props.crossingOver])

  useEffect(() => {
    if (props.data && props.data.playInitially) {
      onClick()
      // setPoweredOn(true);
    }

  }, [props.data])
  useEffect(() => {
    if (poweredOn) {
      props.audioController.playAudioByName(cbRadioAudio);
    } else {
      props.audioController.removeAudio(cbRadioAudio);
    }
  }, [poweredOn])

  const onClick = () => {
    setPoweredOn(!poweredOn);
    props.onPower()
  
  };
  return (
    <div className={`CBRadio  ${props.view}`}>
      <div className={`power-button`} onClick={onClick} />
      </div>
  )
};

export default CBRadio